import type { FC } from 'react'
import type { CartProduct } from '../provider/types'
import ProductRowEditable from '../../shared/product/ProductRowEditable'
import useCartProducts from '../hooks/useCartProducts'
import { toSingleCartProduct } from '../../../../src/utils/shopItemUtils'
import groupTo2DBy from '@g4g/utils/src/groupTo2DBy'

const ShoppingCartProduct: FC<{ products: CartProduct[]; areRemovable?: boolean }> = ({
  products,
  areRemovable,
}) => {
  const product = toSingleCartProduct(products)

  return (
    <>
      {product && (
        <li
          className="pt-4 m-4"
          data-cy="shop-cart-product-row"
          data-cy-spec={product.product.shopItemId}
        >
          <ProductRowEditable shine product={product} isRemovable={areRemovable} />
        </li>
      )}
    </>
  )
}

const ShoppingCartProducts: FC<{ areRemovable?: boolean }> = ({ areRemovable }) => {
  const { products } = useCartProducts()

  return (
    <ul className="divide-y divide-gray-300/40">
      {groupTo2DBy(products, ({ product: { shopItemId } }) => shopItemId).map(
        ([, cartProducts], i) => (
          <ShoppingCartProduct products={cartProducts} areRemovable={areRemovable} key={i} />
        )
      )}
    </ul>
  )
}

export default ShoppingCartProducts
